module.exports = __webpack_public_path__ + "img/singing-under-the-moon.cb66c0d4.jpeg";